import { IVideo } from '@connec10/media-interface/src/entity'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useGetSpecialVideoList } from '../../../modules/video'
import { SP_MAX_WIDTH } from '../../../setting'
import { Box } from '../../atoms'
import { commentList } from '../CommentList/factory'
import { Course } from '../Course'
import { CourseCardList } from '../CourseCardList'

export interface PageHomeProps {
  video: IVideo
}

export const PageHome = ({ video }: PageHomeProps) => {
  // const { videoPlayHistoryList } = useGetListVideoPlayHistory({ page: 1, perPage: 16 })
  // const { videoFavoriteList } = useGetListVideoFavorite({ page: 1, perPage: 16 })
  const { videos = [] } = useGetSpecialVideoList()

  const isSp = useMediaQuery({
    query: `(max-device-width: ${SP_MAX_WIDTH})`
  })

  return (
    <div style={{ width: '100%' }}>
      <Box maxWidth="100%" pb="80px">
        <Box width="100%" mb="56px">
          <Course
            video={video}
            commentList={commentList}
            pdfUrl={video.term.textbookPath ? process.env.REACT_APP_GCS_URL + video.term.textbookPath : ''}
          />
        </Box>

        {videos.length > 0 && (
          <Box px={isSp ? '16px' : '0px'} pl={isSp ? '16px' : '32px'}>
            <Box mb="46px" width="100%" overflow="scroll">
              <CourseCardList
                courseList={videos}
                isViewMore={true}
                title="特別動画「BASIC」"
                titleIcon="special"
                isSort={false}
              />
            </Box>
          </Box>
        )}
        <Box px={isSp ? '16px' : '0px'} pl={isSp ? '16px' : '32px'}>
          {/* @TODO: 最近見た動画とお気に入りはAPI側で動画の情報を返すようにして、CourseCardListに渡すだけにする */}
        </Box>
      </Box>
    </div>
  )
}
